/**
 * @file Was der Nutzer liest, wenn das Oeffnen nicht geklappt hat.
 *
 * Warum das eine eigene Datei ist: Der Beleg erscheint seit dem Umbau in einem
 * ANDEREN Tab. Bleibt der aus, geschieht im Dialog selbst sichtbar gar nichts -
 * der Kunde klickt, wartet und haelt den Knopf fuer kaputt. Diese Zuordnung ist
 * also die einzige Rueckmeldung, die es in diesem Fall gibt, und damit eigene
 * Logik. Als reine Funktion laesst sie sich ohne Renderer pruefen.
 *
 * Die Texte stehen fest verdrahtet hier und nicht in `locales_store`: Die
 * uebrigen Texte dieses Dialogs ("Rechnungen", "Wird geladen....") stehen
 * genauso da, und ein neuer Schluessel waere erst nach dem naechsten
 * Locales-Deploy sichtbar - bis dahin stuende hier der rohe Schluessel.
 */

import { InvoiceTabOutcome } from "./openInvoiceTab";

/**
 * Die Ausgaenge, zu denen es etwas zu sagen gibt.
 *
 * Bewusst NICHT vollstaendig: "shown" braucht keine Meldung, "abandoned" ist
 * im Regelfall der Wunsch des Nutzers (er hat den Wartetab selbst zugemacht),
 * und "busy" ist der zweite Klick auf dieselbe Zeile - eine Fehlermeldung
 * waere in allen drei Faellen falsch.
 *
 * "abandoned" deckt allerdings auch die gescheiterte Umleitung mit ab; der
 * Wartetab schliesst sich dann von selbst, eine Meldung gibt es hier aber
 * nicht, weil `show` beide Lagen mit demselben false meldet.
 */
const MESSAGES: Partial<Record<InvoiceTabOutcome, string>> = {
  none: "Zu dieser Rechnung liegt kein Beleg vor.",
  blocked:
    "Der Beleg konnte nicht geöffnet werden. Bitte erlauben Sie Pop-up-Fenster für CANEI und versuchen Sie es erneut.",
  failed: "Der Beleg konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
};

/**
 * Die sichtbare Rueckmeldung zu einem Ausgang.
 *
 * @param outcome Wie der Versuch ausgegangen ist.
 * @returns Der Text fuer den Nutzer, oder null, wenn es nichts zu melden gibt.
 */
export const invoiceTabMessage = (outcome: InvoiceTabOutcome): string | null =>
  MESSAGES[outcome] ?? null;
